export default "__VITE_ASSET__ChPnnEjZ__"